import React from "react";
import { Label } from "reactstrap";
import Select from "react-select";
import useCurrentDealStore from "stores/DealStore";
import shallow from "zustand/shallow";

const AuctionCompanyDropdown = () => {
	// Deal store
	const { auctionCompanyID, editAuctionCompanyID, auctionCompanies } =
		useCurrentDealStore(
			(state) => ({
				auctionCompanyID: state.deal.auctionCompanyID,
				editAuctionCompanyID: state.editAuctionCompanyID,
				auctionCompanies: state.auctionCompanies,
			}),
			shallow
		);

	const auctionCompaniesList = auctionCompanies.map((obj) => ({
		label: obj.name,
		value: obj.id,
		obj: obj,
	}));

	const selectedOption = auctionCompaniesList.find(
		(element) => element.value === auctionCompanyID
	);

	return (
		<div>
			<Label>Auction Company</Label>
			<Select
				className="mb-3 selector"
				noOptionsMessage={() => "No person available"}
				value={selectedOption || { label: "None", value: null }}
				options={[{ label: "None", value: null }, ...auctionCompaniesList]}
				onChange={(e) => {
					editAuctionCompanyID(e.value);
				}}
			/>
		</div>
	);
};

export default AuctionCompanyDropdown;
